import { useMediaQuery } from 'react-responsive';

const breakpoints = {
  xs: 30 * 16, // 480px
  sm: 48 * 16, // 768px
  md: 70 * 16, // 1120px
  lg: 75 * 16, // 1200px
  xl: 90 * 16, // 1440px
};
const useResponsive = () => {
  const isTablet = useMediaQuery({ query: `(max-width: ${breakpoints.md}px)` });
  const isMobile = useMediaQuery({ query: `(max-width: ${breakpoints.sm}px)` });

  return { isTablet, isMobile };
};

export { breakpoints, useResponsive };
